<template>
  <ConsoleApplication v-bind="$props" :left-nav-items="leftNavItems" disable-cu-selector />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import { useGlobalSearch } from '@console/composables/useGlobalSearch';
import { getAppRoute } from '@console/router';
import { LeftNavigationItem } from '@console/types';
import { ConsoleApplication, consoleApplicationProps } from '@console/ui/ConsoleApplication';
import { useTitle } from '@vueuse/core';
import { SEARCH_TAB_CONFIG } from './searchConfig';

export default defineComponent({
  name: 'App',
  components: {
    ConsoleApplication,
  },

  props: consoleApplicationProps,

  setup() {
    const title = useTitle();
    const route = useRoute();
    const isResultPage = computed(() => route.name === 'root.global-search');
    const globalSearch = useGlobalSearch();
    const searchLeftNavItems = computed<Record<string, LeftNavigationItem[]>>(() => ({
      'Global Search': SEARCH_TAB_CONFIG.map(tab => ({
        enabled: () => true,
        title: tab.title,
        icon: tab.icon,
        exact: true,
        to: getAppRoute('-root-', globalSearch.getRouteParams(tab.type)),
        count: globalSearch.resultsCount.value?.[tab.legacyKey] || globalSearch.newResultsCount.value?.[tab.newKey],
      })),
    }));
    const leftNavItems = computed(() => (isResultPage.value ? searchLeftNavItems.value : undefined));

    title.value = 'Console';

    return { leftNavItems, searchLeftNavItems };
  },
});
</script>
